import * as Yup from 'yup';

export const FilterFormSchema = Yup.object().shape({
    status: Yup.string(),
    category: Yup.string(),
});
